<div>
  <div class="form-group">
    <label for="searchText"> {{ searchertext }}</label>
    <input
      [required]="required"
      [disabled]="disabled"
      class="form-control"
      autocomplete="off"
      type="text"
      name="{{ searchertext }}"
      [(ngModel)]="searchText"
      (keyup)="change($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keyup.enter)="onEnter()"
    />
    <ul
      *ngIf="showList"
      class="list-group"
      style="
        max-height: 380px;
        overflow: scroll;
        border: 1px solid #000;
        position: absolute;
        z-index: 9;
        width: 40%;
        cursor: pointer;
      "
    >
      <li *ngFor="let item of filteredItems" (click)="itemSelected(item)" class="list-group-item">
        {{ item[key] }}
      </li>
    </ul>
  </div>
</div>
